// Organization Data Table Component
import React, { useMemo } from 'react';
import { DataTable } from '@/components';
import { useOrganizationTableColumns } from './OrganizationDataTableConfig';
import { IOrganizationRowData } from '@/types/admin/organizations';
import { IDataTableResponse } from '@/types/admin/dataTable';

interface OrganizationDataTableProps {
  data: {
    rows: IOrganizationRowData[];
    count: number;
  };
  isLoading: boolean;
  onOrganizationSelect: (organization: IOrganizationRowData) => void;
  updateCsvData?: (data: IOrganizationRowData[]) => void;
  showSearch?: boolean;
}

export const OrganizationDataTable: React.FC<OrganizationDataTableProps> = ({
  data,
  isLoading,
  onOrganizationSelect,
  updateCsvData,
  showSearch = false,
}) => {
  const organizationTableColumns = useOrganizationTableColumns();
  // Transform data to match generic DataTable interface
  const tableData: IDataTableResponse<IOrganizationRowData> = useMemo(() => ({
    rows: data.rows || [],
    count: data.count || 0,
  }), [data]);

  const handleRowSelect = (organization: IOrganizationRowData, index: number) => {
    onOrganizationSelect(organization);
  };

  return (
    <DataTable
      data={tableData}
      columns={organizationTableColumns}
      isLoading={isLoading}
      searchPlaceholder="Search organizations..."
      onRowSelect={handleRowSelect}
      updateCsvData={updateCsvData}
      emptyStateType="organization"
      mobileColumnCount={2}
      showSearch={showSearch}
      showSort={true}
      showFilter={true}
    />
  );
};

